import { render, staticRenderFns } from "./modal-terms.vue?vue&type=template&id=0181a113&scoped=true"
import script from "./modal-terms.vue?vue&type=script&lang=js"
export * from "./modal-terms.vue?vue&type=script&lang=js"
import style0 from "./modal-terms.vue?vue&type=style&index=0&id=0181a113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0181a113",
  null
  
)

export default component.exports